import { getDaysInMonth, getDayInterval } from '@/filters/index'
import { v4 as uuidv4 } from 'uuid'
// 根据出勤天数、结算方式、月份计算合同计量数量, monthTime不传默认每月30天计算
export function calCalculateNum(attendanceDays, settleType, monthTime) {
  var calculateNum = 0
  if (!attendanceDays) {
    calculateNum = 0
  } else {
    if (settleType === '计天') {
      calculateNum = attendanceDays
    } else if (settleType === '计时') {
      calculateNum = attendanceDays * 8
    } else if (settleType === '计月') {
      calculateNum = parseFloat(
        (attendanceDays / (monthTime ? getDaysInMonth(monthTime) : 30)).toFixed(
          4
        )
      )
    } else {
      calculateNum = 1
    }
  }
  return calculateNum
}
// 根据身份证号获取人员性别、生日、年龄
export function analysisIdCard(idCard) {
  var result = {}
  var sexNum = parseInt(idCard.slice(-2, -1))
  if (sexNum % 2 === 0) {
    result.sex = '女'
  } else if (sexNum % 2 === 1) {
    result.sex = '男'
  }
  result.birthday =
    idCard.slice(6, 10) +
    '-' +
    idCard.slice(10, 12) +
    '-' +
    idCard.slice(12, 14)
  result.age = Math.round(getDayInterval(result.birthday) / 365)
  return result
}
// 根据家庭住址获取籍贯以及省、市、州、县、区、镇、村、详细地址
export function analysisAddress(address) {
  var result = {}
  let provinceIndex = 0
  if (address.indexOf('省') !== -1) {
    provinceIndex = address.indexOf('省') + 1
  } else if (address.indexOf('省') === -1 && address.indexOf('自治区') !== -1) {
    provinceIndex = address.indexOf('自治区') + 3
  } else {
    provinceIndex = address.indexOf('特别行政区') + 5
  }
  result.province = address.slice(0, provinceIndex)
  let cityIndex = 0
  if (address.indexOf('自治州', provinceIndex) !== -1) {
    cityIndex = address.indexOf('自治州', provinceIndex) + 3
  } else if (
    address.indexOf('自治州', provinceIndex) === -1 &&
    address.indexOf('市', provinceIndex) !== -1
  ) {
    if (
      address.indexOf('县', provinceIndex) !== -1 &&
      address.indexOf('县', provinceIndex) <
        address.indexOf('市', provinceIndex)
    ) {
      cityIndex = 0
    } else {
      cityIndex = address.indexOf('市', provinceIndex) + 1
    }
  }
  result.city = address.slice(provinceIndex, cityIndex)
  let countyIndex = 0
  if (address.indexOf('自治县', cityIndex) !== -1) {
    countyIndex = address.indexOf('自治县', cityIndex) + 3
  } else if (
    address.indexOf('自治县', cityIndex) === -1 &&
    address.indexOf('县', cityIndex) !== -1
  ) {
    countyIndex = address.indexOf('县', cityIndex) + 1
  } else {
    if (
      address.indexOf('市', cityIndex) !== -1 &&
      address.indexOf('市', cityIndex) !== address.indexOf('市', provinceIndex)
    ) {
      countyIndex = address.indexOf('市', cityIndex) + 1
    } else if (
      address.indexOf('区', cityIndex) !== -1 &&
      address.indexOf('自治区') === -1 &&
      address.indexOf('特别行政区') === -1
    ) {
      countyIndex = address.lastIndexOf('区') + 1
    }
  }
  result.county = address.slice(
    cityIndex ? cityIndex : provinceIndex,
    countyIndex
  )
  result.nativePlace = result.province + result.city + result.county
  result.exactAddress = address.slice(countyIndex ? countyIndex : cityIndex)
  return result
}

// 随机生成uid
export function guid() {
  return uuidv4()
}

// 根据线路编号及起讫桩号里程值拼接其起讫桩号
export function getStartEndStake(data) {
  var startEndStake = {}
  const s = parseFloat(data.startStake)
  const e = parseFloat(data.endStake)
  const c = parseFloat(data.centerStake)
  function getStake(l, m) {
    var stake = ''
    if (m < 10) {
      stake = l + '0+00' + m
    } else if (m < 100 && m >= 10) {
      stake = l + '0+0' + m
    } else if (m >= 100) {
      const r = (m % 1000).toFixed(3)
      let odd = ''
      if (r < 10) {
        odd = '00' + r
      } else if (r < 100 && r >= 10) {
        odd = '0' + r
      } else if (r >= 100) {
        odd = '' + r
      }
      stake = l + parseInt(m / 1000) + '+' + odd
    }
    return stake
  }
  startEndStake.startStake = getStake(data.lineCode, s)
  startEndStake.endStake = getStake(data.lineCode, e)
  startEndStake.centerStake = getStake(data.lineCode, c)
  startEndStake.startEndStake =
    startEndStake.startStake + '\xa0-\xa0' + startEndStake.endStake
  return startEndStake
}

// 获取小数位数
export function getDecimalCount(num) {
  let count
  try {
    count = num.toString().split('.')[1].length
  } catch (e) {
    count = 0
  }
  return count
}

/** 金额保留到分（最多两位小数），避免浮点尾巴如 30600.010000000002 */
export function roundMoney(num) {
  if (num == null || num === '') return 0
  const n = Number(num)
  if (!Number.isFinite(n)) return 0
  return Number(n.toFixed(2))
}

/** 展示用：最多两位小数，整数不强制补 .00 */
export function formatMoney(num) {
  const n = roundMoney(num)
  return Number.isInteger(n) ? String(n) : n.toFixed(2)
}

const MONEY_KEYS = [
  'grossPay',
  'cutPayment',
  'overtimePay',
  'currentOwePay',
  'currentShouldPay',
  'currentActualPay',
  'replacePay',
  'actualPay',
  'cumuShouldPay',
  'cumuActualPay',
  'cumuOwePay',
  'priceUnit'
]

/** 将对象上的金额字段统一到分 */
export function roundMoneyFields(obj, keys) {
  if (!obj || typeof obj !== 'object') return obj
  const list = keys && keys.length ? keys : MONEY_KEYS
  list.forEach((key) => {
    if (obj[key] == null || obj[key] === '') return
    const n = Number(obj[key])
    if (Number.isFinite(n)) obj[key] = roundMoney(n)
  })
  return obj
}

// 修复精度问题--加法
export function decimalAdd(num1, num2) {
  if (num1 == null || num2 == null) return
  const max = Math.pow(
    10,
    Math.max(getDecimalCount(num1), getDecimalCount(num2))
  )
  if (getDecimalCount(num1) == getDecimalCount(num2)) {
    num1 = (num1 + '').replace('.', '')
    num2 = (num2 + '').replace('.', '')
  } else if (getDecimalCount(num1) > getDecimalCount(num2)) {
    const fillZero = '0'.repeat(getDecimalCount(num1) - getDecimalCount(num2))
    num1 = (num1 + '').replace('.', '')
    num2 = (num2 + '').replace('.', '') + fillZero
  } else {
    const fillZero = '0'.repeat(getDecimalCount(num2) - getDecimalCount(num1))
    num1 = (num1 + '').replace('.', '') + fillZero
    num2 = (num2 + '').replace('.', '')
  }
  return (Number(num1) + Number(num2)) / max
}
// 修复精度问题--减法
export function decimalSub(num1, num2) {
  if (num1 == null || num2 == null) return
  return decimalAdd(num1, -num2)
}

// 修复精度问题--乘法
export function decimalMul(num1, num2) {
  if (num1 == null || num2 == null) return
  const sum = getDecimalCount(num1) + getDecimalCount(num2)
  return (
    (Number((num1 + '').replace('.', '')) *
      Number((num2 + '').replace('.', ''))) /
    Math.pow(10, sum)
  )
}

// 修复精度问题--除法
export function decimalDiv(num1, num2) {
  if (num1 == null || num2 == null) return
  const count1 = getDecimalCount(num1)
  const count2 = getDecimalCount(num2)
  const formatNum1 = Number((num1 + '').replace('.', ''))
  const formatNum2 = Number((num2 + '').replace('.', ''))
  if (count2 - count1 < 0) {
    // 由于 Math.pow(10, count2 - count1) 为小数，需要处理精度问题
    return decimalMul(formatNum1 / formatNum2, Math.pow(10, count2 - count1))
  } else {
    return (formatNum1 / formatNum2) * Math.pow(10, count2 - count1)
  }
}

export function getEnglishInitials(str) {
  const chineseChars = str.trim().split('')
  let englishInitials = ''
  chineseChars.forEach((char) => {
    const code = char.charCodeAt(0)
    if (code >= 19968 && code <= 40869) {
      englishInitials += String.fromCharCode(65 + ((code - 19968) % 26))
    } else {
      englishInitials += char
    }
  })
  return englishInitials
}
